/**
 * AAA Distributor — Route + Estimated Delivery Date
 *
 * Estimated Delivery Date marks the checkout button with `.ds-disable` and
 * attaches onclick to `.cart__ctas`, so Route never sees the click.
 *
 * This script lets Route intercept when checkout is enabled, keeps EDD's
 * date + redirect on the released click, and ignores gray / no-date clicks
 * (`.ds-disable-opacity` or disabled) so the datepicker stays put.
 *
 * Theme install:
 *   1. Online Store → Themes → Edit code
 *   2. Assets → Add a new asset → upload this file as
 *      `route-edd-checkout-unlock.js`
 *   3. In `layout/theme.liquid`, before </body>, add:
 *        <script src="{{ 'route-edd-checkout-unlock.js' | asset_url }}" defer></script>
 */
(function routeEddCheckoutUnlock() {
  if (window.__routeEddUnlock) return;
  window.__routeEddUnlock = true;

  var STYLE_ID = "route-edd-checkout-unlock";
  var BUTTON_SEL = 'button[name="checkout"], #checkout, #CartDrawer-Checkout';
  var WRAP_SEL = ".cart__ctas";
  var scheduled = false;
  var wrapping = false;

  function isCheckoutButton(el) {
    if (!el || el.nodeType !== 1) return false;
    try {
      return el.matches(BUTTON_SEL);
    } catch (e) {
      return false;
    }
  }

  function isBlockedButton(el) {
    return Boolean(
      el &&
        (el.disabled ||
          el.hasAttribute("disabled") ||
          el.getAttribute("aria-disabled") === "true" ||
          (el.classList && el.classList.contains("ds-disable-opacity"))),
    );
  }

  function isEnabledCheckoutButton(el) {
    return isCheckoutButton(el) && !isBlockedButton(el);
  }

  function isRouteWidgetClick(event) {
    var path = event.composedPath ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n && n.tagName && n.tagName.toLowerCase() === "route-cart-preferred") {
        var origin = path[0];
        if (origin && isCheckoutButton(origin)) return false;
        if (origin && origin.closest && origin.closest(BUTTON_SEL)) return false;
        return true;
      }
    }
    return false;
  }

  function blockedCheckoutFromEvent(event) {
    if (!event) return null;
    if (event.submitter && isCheckoutButton(event.submitter) && isBlockedButton(event.submitter)) {
      return event.submitter;
    }
    var path = event.composedPath ? event.composedPath() : [event.target];
    var i;
    var n;
    var btn;
    for (i = 0; i < path.length; i++) {
      n = path[i];
      if (!n || n.nodeType !== 1) continue;
      if (isCheckoutButton(n) && isBlockedButton(n)) return n;
      if (n.matches && n.matches(WRAP_SEL)) {
        btn = n.querySelector(BUTTON_SEL);
        if (isBlockedButton(btn)) return btn;
      }
    }
    return null;
  }

  function injectCss() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = [
      'button[name="checkout"].ds-disable:not(:disabled):not(.ds-disable-opacity),',
      "#checkout.ds-disable:not(:disabled):not(.ds-disable-opacity),",
      "#CartDrawer-Checkout.ds-disable:not(:disabled):not(.ds-disable-opacity) {",
      "  pointer-events: auto !important;",
      "}",
      ".cart__checkout-button.ds-disable.ds-disable-opacity,",
      'button[name="checkout"].ds-disable-opacity,',
      "#checkout.ds-disable-opacity,",
      "#CartDrawer-Checkout.ds-disable-opacity,",
      'button[name="checkout"]:disabled,',
      "#checkout:disabled,",
      "#CartDrawer-Checkout:disabled {",
      "  pointer-events: none !important;",
      "  cursor: not-allowed !important;",
      "}",
    ].join("\n");
    (document.head || document.documentElement).appendChild(style);
  }

  function shouldPassToEdd(event) {
    if (!event) return false;
    if (isRouteWidgetClick(event)) return false;
    if (blockedCheckoutFromEvent(event)) return false;
    var target = event.target;
    if (!target || !target.closest) return false;
    var btn = isCheckoutButton(target) ? target : target.closest(BUTTON_SEL);
    return isEnabledCheckoutButton(btn);
  }

  function swallowGrayCheckout(event) {
    if (isRouteWidgetClick(event)) return;
    if (!blockedCheckoutFromEvent(event)) return;
    if (event.preventDefault) event.preventDefault();
    if (event.stopPropagation) event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  function wrapOnclick(el) {
    if (!el) return;
    var current = el.onclick;
    if (current && current.__routeEddFilter) return;

    if (typeof current === "function") {
      el.__routeEddOriginal = current;
    }
    var original = el.__routeEddOriginal;
    if (typeof original !== "function") return;

    var filtered = function (event) {
      if (!shouldPassToEdd(event)) return false;
      return original.call(this, event);
    };
    filtered.__routeEddFilter = true;
    el.onclick = filtered;
  }

  function wrapContainers() {
    if (wrapping) return;
    wrapping = true;
    try {
      var nodes = document.querySelectorAll(WRAP_SEL);
      for (var i = 0; i < nodes.length; i++) wrapOnclick(nodes[i]);
      if (window.dsMainBlock && window.dsMainBlock.parentNode) {
        wrapOnclick(window.dsMainBlock.parentNode);
      }
    } finally {
      wrapping = false;
    }
  }

  function scheduleWrap() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(function () {
      scheduled = false;
      wrapContainers();
    }, 200);
  }

  function start() {
    injectCss();
    wrapContainers();
    document.addEventListener("click", swallowGrayCheckout, true);
    document.addEventListener("submit", swallowGrayCheckout, true);
    if (typeof MutationObserver === "function") {
      new MutationObserver(scheduleWrap).observe(document.body || document.documentElement, {
        subtree: true,
        childList: true,
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
